<template lang="pug">
.page-holder--business-rules
  h2.mb-S Business rules
  .table-toolbar.business-rules-table-toolbar
    BriqCheckboxStandalone(
        label="Show rules for this day" 
        v-model="rulesForThisDay" 
        data-test-id="rules-for-this-day" 
        class="checkboxes checkboxes--inline checkboxes--shrink-wrapped"
        )
    BriqCheckboxStandalone(
        label="Hide rules from the past" 
        v-model="hideRulesFromThePast" 
        data-test-id="hide-rules-from-the-past" 
        class="checkboxes checkboxes--inline checkboxes--shrink-wrapped"
        )
    a(class="button button--confirm button--large" :href="addBusinessRuleUrl" data-test-id="new-item") New item
  .business-rules-table-holder
    BusinessRulesTable(
      :key="hideRulesFromThePast"
      :businessRules="innerBusinessRules" 
      :hideRulesFromThePast="hideRulesFromThePast" 
      :rulesForThisDay="rulesForThisDay"
      :activitiesLookup="activitiesLookupArr" 
      :scheduleKeys="scheduleKeysArr" 
      ref="BusinessRulesTable"
    )
</template>

<script>
import BusinessRulesTable from './BusinessRulesTable.vue'
import tryCall from '@v/mixins/tryCall.js'

export default {
  name: 'BusinessRules',
  components: { BusinessRulesTable },
  mixins: [tryCall],
  props: {
    addBusinessRuleUrl: {
      type: String,
      required: true,
    },
    businessRules: {
      type: Array,
      required: true,
    },
    activitiesLookup: {
      type: Object,
      required: true,
    },
    scheduleKeys: {
      required: true,
    },
  },
  computed: {
    activitiesLookupArr() {
      return Object.values(this.activitiesLookup)
    },
    scheduleKeysArr() {
      return Object.values(this.scheduleKeys)
    },
  },
  data() {
    return {
      innerBusinessRules: null,
      rulesForThisDay: false,
      hideRulesFromThePast: true,
    }
  },
  methods: {
    async sortScheduleRules() {
      const formData = new FormData()

      this.innerBusinessRules.forEach(function(item) {
        !item.inPast ? formData.append(`order[${item.Key}]`, item.Priority) : null
      })

      return await this.tryCall(async () => await this.$apiClient.post('schedule/sort', formData))
    },
  },
  created() {
    this.innerBusinessRules = this.businessRules.sort((a, b) => b.Priority - a.Priority)

    this.$bus.$on('reorder-business-rules', removedProductId => {
      this.sortScheduleRules()
    })
  },
}
</script>

<style scoped lang="stylus">
.business-rules-table-toolbar
  padding-top 23px
  justify-content space-between
</style>
